import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { AlertClientModule } from './alert-client/alert-client.module';
import { AlertsModule } from './alerts-abonnee/alerts.module';
import { CallOfferModule } from './call-offer-abonnee/call-offer.module';
import { CandidatsModule } from './candidats-abonnee/candidats.module';
import { ChatModule } from './chat/chat.module';
import { ClientsModule } from './clients/clients.module';
import { ConsultantModule } from './consultant/consultant.module';
import { CraModule } from './cra-abonne/cra.module';
import { CraClientFinalModule } from './cra-client-final/cra-client-final.module';
import { EsnJobOfferModule } from './esn-job-offer/esn-job-offer.module';
import { EvaluationModule } from './evaluation-abonnee/evaluation.module';
import { EvaluationClientModule } from './evaluation-client/evaluation-client.module';
import { ProjectModule } from './projects/project.module';
import { SettingsModule } from './settings/settings.module';
import { UserClientModule } from './user-client/user-client.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CallOfferClientComponent } from './call-offer-client/call-offer-client.component';
import { CallOfferNonAbonneComponent } from './call-offer-non-abonne/call-offer-non-abonne.component';
import { CandidatNonAbonneComponent } from './candidat-non-abonne/candidat-non-abonne.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { EmployeeComponent } from './employee/employee.component';
import { ExternalConsultantComponent } from './external-consultant/external-consultant.component';
import { ListAbonnementsComponent } from './list-abonnements/list-abonnements.component';
import { ListUsersComponent } from './list-users/list-users.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { SupplierComponent } from './supplier/supplier.component';
import { UserNonAbonneComponent } from './user-non-abonne/user-non-abonne.component';
import { HeaderComponent } from './../widgets/header/header.component';
import { SidebarClientComponent } from './../widgets/sidebar-client/sidebar-client.component';
import { RateWegestuComponent } from './rate-wegestu/rate-wegestu.component';
import { MessageEsnComponent } from './message-esn/message-esn.component';
import { TutoEsnComponent } from './tuto-esn/tuto-esn.component';
import { RateEsnComponent } from './rate-esn/rate-esn.component';
import { FaqEsnComponent } from './faq-esn/faq-esn.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { ContactComponent } from './contact/contact.component';
import { DossierComponent } from './dossier/dossier.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatTableModule } from '@angular/material/table';
import { FaqModule } from './faq/faq.module';
import { PaginationModule } from './../shared/components/pagination/pagination.module';
import { FieldErrorModule } from './../shared/components/shared-field-error/field-error.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxIntlTelephoneInputModule } from 'ngx-intl-telephone-input';
import { DetailcompanyComponent } from './detailcompany/detailcompany.component';
import { RatingModule } from 'ngx-bootstrap/rating';
import { ProjectComponent } from './projects/components/project-list/project.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { DetailsOfferComponent } from './details-offer/details-offer.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CalendarModule } from 'primeng/calendar';
import { TutoclientComponent } from './tuto-client/tutoclient.component';
import { CandidaturecallofferComponent } from './candidaturecalloffer/candidaturecalloffer/candidaturecalloffer.component';
import { CandidatclientfinalComponent } from './candidat-client-final/candidatclientfinal/candidatclientfinal.component';
import { OfferDetailsComponent } from './list-abonnements/components/offer-details/offer-details.component';
import { ChangeOfferComponent } from './list-abonnements/components/change-offer/change-offer.component';
import { QuillModule } from 'ngx-quill';
import { CallOffreBaremeComponent } from './call-offre-bareme/call-offre-bareme.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NotificationComponent } from './notification/notification/notification.component';
import { ListesncallofferComponent } from './list-esn-calloffer/listesncalloffer.component';
import { SuggestioncallofferclientfinalComponent } from './suggestion-calloffer-clientfinal/suggestioncallofferclientfinal.component';
import { ProfilcandidatanonymeComponent } from './profil-candidat-anonyme/profilcandidatanonyme.component';
import { PaymentDetailsComponent } from './list-abonnements/components/payment-details/payment-details.component';
import { PaymentSuccessComponent } from './list-abonnements/components/payment-success/payment-success.component';
import { PaymentFailedComponent } from './list-abonnements/components/payment-failed/payment-failed.component';
import { AddappeloffreComponent } from './add-call-offre/addappeloffre/addappeloffre.component';
import { DetailcallofferclientfinalComponent } from './detail-calloffer-clientfinal/detailcallofferclientfinal/detailcallofferclientfinal.component';
import { UpdateIntervenantComponent } from './update-intervenant/update-intervenant/update-intervenant.component';

import { DetailEmployeeComponent } from './detail-employee/detail-employee.component';
import { MatInputModule } from '@angular/material/input';
import { CvCandidatAnonymeComponent } from './cv-candidat_anonyme/cv-candidat-anonyme/cv-candidat-anonyme.component';
import { ChangeEmailComponent } from './change-email/change-email.component';
import { ConsultantEnattenteComponent } from './consultant-enattente/consultant-enattente.component';
import { ContactEsnComponent } from './contact-esn/contact-esn.component';
import { EntreprisesModule } from './entreprises/entreprises.module';
import { JobOfferModule } from './job-offer/job-offer.module';
import { DashboardclientComponent } from './dashboard-client/dachbordclient/dashboardclient.component';
import { DownGradeModalComponent } from '@shared/modals/down-grade-modal/down-grade-modal.component';
import { ChangeOfferSuccessComponent } from './list-abonnements/components/change-offer-success/change-offer-success.component';
import { DetailsProfilModule } from './details-profil/details-profil.module';
import { EvaluationPvComponent } from './evaluation-pv/evaluation-pv.component';
import {SharedModule} from 'app/shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
import { AddIntervenantComponent } from './list-users/add-intervenant/add-intervenant.component';
import { UpdateIntervenantComponentNew } from './list-users/update-intervenant/update-intervenant.component';
@NgModule({
  declarations: [
    MainComponent,
    DashboardComponent,
    CallOfferClientComponent,
    CallOfferNonAbonneComponent,
    CandidatNonAbonneComponent,
    ContactUsComponent,
    ContactEsnComponent,
    EmployeeComponent,
    ExternalConsultantComponent,
    ListAbonnementsComponent,
    ListUsersComponent,
    SubscribeComponent,
    SupplierComponent,
    UserNonAbonneComponent,
    HeaderComponent,
    SidebarClientComponent,
    RateWegestuComponent,
    MessageEsnComponent,
    TutoEsnComponent,
    RateEsnComponent,
    FaqEsnComponent,
    DetailsOfferComponent,
    InvoicesComponent,
    ContactComponent,
    DossierComponent,
    DetailcompanyComponent,
    ProjectComponent,
    ChangePasswordComponent,
    TutoclientComponent,
    CandidaturecallofferComponent,
    CandidatclientfinalComponent,
    OfferDetailsComponent,
    ChangeOfferComponent,
    CallOffreBaremeComponent,
    NotFoundComponent,
    NotificationComponent,
    ListesncallofferComponent,
    SuggestioncallofferclientfinalComponent,
    ProfilcandidatanonymeComponent,
    PaymentDetailsComponent,
    PaymentSuccessComponent,
    PaymentFailedComponent,
    ChangeOfferSuccessComponent,
    DashboardclientComponent,
    AddappeloffreComponent,
    DetailcallofferclientfinalComponent,
    UpdateIntervenantComponent,
    DetailEmployeeComponent,
    CvCandidatAnonymeComponent,
    ChangeEmailComponent,
    ConsultantEnattenteComponent,
    DownGradeModalComponent,
    EvaluationPvComponent,
    AddIntervenantComponent,
    UpdateIntervenantComponentNew
  ],

  imports: [
    CommonModule,
    MainRoutingModule,
    AlertClientModule,
    AlertsModule,
    CallOfferModule,
    CandidatsModule,
    ChatModule,
    ClientsModule,
    EntreprisesModule,
    ConsultantModule,
    CraModule,
    CraClientFinalModule,
    JobOfferModule,
    EsnJobOfferModule,
    EvaluationModule,
    EvaluationClientModule,
    FaqModule,
    ProjectModule,
    SettingsModule,
    UserClientModule,
    NgSelectModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    MatTableModule,
    NgbModule,
    PaginationModule,
    FieldErrorModule,
    NgxIntlTelInputModule,
    NgxIntlTelephoneInputModule,
    RatingModule.forRoot(),
    ModalModule.forRoot(),
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    BsDatepickerModule.forRoot(),
    CalendarModule,
    DetailsProfilModule,
    QuillModule.forRoot(),
    SharedModule,
    MatMenuModule
  ]
})
export class MainModule { }
